export const __DEV__ = process.env.NODE_ENV !== 'production'
export const ACC_FACTOR_MIN = 0.6
export const ACC_FACTOR_MAX = 0.96
export const WHEELEVENTS_TO_MERGE = 2
export const WHEELEVENTS_TO_ANALAZE = 5
